import {
  Box, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import '../../assests/css/bannerStyle.css';

const SimpleBanner = ({
  title, subtitle, backgroundImage,
}) => (
  subtitle ? (
    <Box className="mainBox flexCenter" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <Box className="boxTitlesBanner">
        <Typography variant="h1" fontWeight={700} className="lettersWhiteOnly">{title}</Typography>
        <Box className="spaceBetween widthBoxTypography">
          <Typography variant="h6" fontSize={24} className="lettersWhiteOnly">{subtitle}</Typography>
        </Box>
      </Box>
    </Box>
  ) : (
    <Box className="mainBoxNoSubtitle flexCenter" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <Box className="boxTitlesBanner">
        <Typography variant="h1" fontWeight={700} className="lettersWhiteOnly">{title}</Typography>
      </Box>
    </Box>
  )
);

SimpleBanner.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  backgroundImage: PropTypes.string,
};

SimpleBanner.defaultProps = {
  title: '',
  subtitle: '',
  backgroundImage: '',
};

export default SimpleBanner;
